import { render } from "./BookingForm.vue?vue&type=template&id=5938d592&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"

import "./BookingForm.vue?vue&type=style&index=0&id=5938d592&lang=css"
import "./BookingForm.vue?vue&type=style&index=1&id=5938d592&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5938d592"]])

export default __exports__